import React, { ReactNode } from "react";

import Card from "antd/es/card";
import cn from "classnames";

import styles from "./BillingInfo.module.scss";

interface Props {
  children?: ReactNode | ReactNode[];
  className?: string;
  text?: ReactNode;
  title?: ReactNode;
}

const BillingInfo: React.FC<Props> = ({ children, className, text, title }) => {
  return (
    <Card className={cn(styles.container, className)}>
      {title && <p className={styles.title}>{title}</p>}
      {text && <span className={styles.description}>{text}</span>}
      {children}
    </Card>
  );
};

export default BillingInfo;
